import React, { ReactElement } from 'react';
import { ErrorPage } from '@components';
import { useFormikContext } from 'formik';
import { iReviewFormValues } from '@services/ReviewService';

function ReviewErrorPage(): ReactElement {
  const { values }: { values: iReviewFormValues } = useFormikContext();
  return (
    <>
      <ErrorPage errorMessage={values.submissionError} />
    </>
  );
}

export default ReviewErrorPage;
